import { css, useTheme } from '@emotion/react'
function Section({
    children,
    backgroundImage,
    backgroundColor,
    parallax = false,
    style
}) {
    const theme = useTheme()
    return (
        <section
            css={css`
                ${backgroundColor &&
                `background-color: ${theme.colors[backgroundColor]}`};
                background-repeat: no-repeat;
                ${backgroundImage &&
                `background-image: url(${backgroundImage}); background-size: cover; background-position: top;`};
                ${parallax && 'background-attachment: fixed;'};
                ${style};
            `}
        >
            <div className="px-6 lg:px-20 xl:px-28 2xl:px-52 mx-auto py-10">
                {children}
            </div>
        </section>
    )
}

export default Section
